import styled from 'styled-components'

export const InputWrapper = styled.div`
	margin-bottom: 12px;

	label {
		display: block;
	}

	input {
		font-size: 16px;
		line-height: 24px;
		color: black;
		border: none;
		border-bottom: 1px solid black;
		padding: 16px;
		padding-left: 0;
		border-radius: 0;
		box-shadow: none;
		outline: none;
		display: inline-block;
		width: 100%;
		height: auto;
		font-family: Open Sans, serif;
		font-style: normal;
		font-weight: normal;
		background-color: #ffffff;
		overflow: hidden;
		box-sizing: border-box;

		&::placeholder {
			color: black;
		}
	}
`
